import React from "react"


interface Props{
    colorsData: any
    handleOpenQuotation: any
    isCollapseQuotation: any
}

interface State{}

class Quotation extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {

        }
    }

    render(): React.ReactNode {
        return(
            <div 
                className={!this.props.isCollapseQuotation ? "quotation-btn" : "quotation-btn-collapse"}
                //style={{backgroundColor: this.props.colorsData ? this.props.colorsData.main_buttons:""}}
                onClick = {() => {
                    this.props.handleOpenQuotation()
                }}
            >
                {/* <img src={Mobile} alt=""></img> */}
                <div className="quotation-title-btn">Cotizar</div>
            </div>
        )
    }
}

export default Quotation